// extracted by mini-css-extract-plugin
export default {"container":"default-default-view_container","pageContainer":"default-default-view_pageContainer","noticeSection":"default-default-view_noticeSection"};